export default __webpack_public_path__ + "static/media/email.e0703334.svg";